import * as React from 'react';
import { NotFound } from 'react-admin';

export default () => <NotFound title='' />;
